import React from 'react';
const NotFound = () => {
    return (React.createElement("div", null,
        React.createElement("h1", null, "404 - Page Not Found"),
        React.createElement("p", null,
            React.createElement("a", { href: "/" }, "Return to home"))));
};
export default NotFound;
